<template>
  <div>
    <tax-return-sidebar :clients="clients" :tax="tax" />
    <tax-filter
      :clients="clients"
      :companies="companies"
      :value="filters"
      @input="applyFilters"
      @clear="clear"
    />
    <vs-row>
      <vs-col vs-lg="12" vs-sm="12" class="p-2">
        <vx-card style="min-height: 85vh" class="px-1">
          <vs-row id="tax-return-loading">
            <div class="vx-col w-full">
              <vs-table :data="taxReturnList">
                <template slot="header">
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    icon="icon-plus"
                    class="mx-2"
                    @click="addTaxReturn"
                    v-show="hasPermission(['IU TAX RETURN EDIT'])"
                  >
                    {{ $t('tax_return') }}
                  </vs-button>
                  <vs-button
                    color="success"
                    icon-pack="feather"
                    icon="icon-check"
                    class="mx-2"
                    @click="openConfirm"
                    v-show="selected.length > 0"
                  >
                    {{ $t('approve') }}
                  </vs-button>

                  <div class="con-input-search vs-table--search">
                    <input
                      class="input-search vs-table--search-input"
                      type="text"
                      v-model="params.search"
                      @keyup.enter="tableRefresh()"
                    />
                    <vs-icon icon="search"></vs-icon>
                  </div>
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-filter"
                    class="mx-2"
                    radius
                    @click="openFilter"
                  ></vs-button>
                </template>
                <template slot="thead">
                  <th><vs-checkbox v-model="selectAllCheckBox" 
                  icon-pack="feather" 
                  :icon="selectAllIcon"
                   class="select-all-chexkbox ml-0 qb-sticky"
                   :disabled="requestedTax.length==0"></vs-checkbox></th>
                  <th-sort :text="$t('client')"         column="cl.ClientName " @sort="handleClickSort"/>
                  <th-sort :text="$t('company')"        column="com.CompanyName " @sort="handleClickSort"/>
                  <th-sort :text="$t('period')"         column="tax_return.period" @sort="handleClickSort"/>
                  <th class="qb-sticky">
                                      {{ $t('total') }}
                  </th>                  
                  <th-sort :text="$t('status')"         column="tax_return.status" @sort="handleClickSort"/>

                  <th class="qb-sticky">
                    {{ $t('actions') }}
                  </th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :style="{ width: '2vw' }" >
                      <div v-if="data[indextr].status == 'REQUESTED'">
                        <vs-checkbox
                          :vs-value="data[indextr].id"
                          v-model="selected"
                          v-show="hasPermission(['IU TAX RETURN EDIT'])"
                        ></vs-checkbox>
                      </div>
                    </vs-td>
                    <vs-td :style="{ width: '30vw' }"  class="text-left">
                      {{ data[indextr].client_name }}
                    </vs-td>
                    <vs-td :style="{ width: '30vw' }"  class="text-left">
                      {{ data[indextr].CompanyName }}
                    </vs-td>

                    <vs-td :style="{ width: '25vw' }" class="text-left">
                      {{ data[indextr].period }}
                    </vs-td>

                    <vs-td :style="{ width: '15vw' }" class="text-right">
                      {{ `$${formatNumber(data[indextr].total, 2)} MXN ` }}
                    </vs-td>
                    <vs-td :style="{ width: '15vw' }" class="text-left">
                      {{
                        data[indextr].status == 'REQUESTED'
                          ? $t('requested')
                          : $t('paid')
                      }}
                    </vs-td>
                    <vs-td :data="data[indextr].id" :style="{ width: '13vw' }">
                      <vx-tooltip
                        :text="$t('show_pdf')"
                        style="display: inline-flex"
                      >
                        <feather-icon
                          @click="showPdf(data[indextr].file)"
                          icon="FileTextIcon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        />
                      </vx-tooltip>

                      <vx-tooltip
                        :text="$t('edit')"
                        style="display: inline-flex"
                        v-if="data[indextr].status === 'REQUESTED'"
                      >
                        <feather-icon
                          @click="updateTaxReturn(data[indextr])"
                          icon="EditIcon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        />
                      </vx-tooltip>
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td colspan="100%">
                      <div
                        v-if="data.length"
                        v-observe-visibility="infiniteHandler"
                      ></div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import accounting from '@/http/requests/accounting'
import moduleAccounting from '@/store/accounting/moduleAccounting.js'
import TaxReturnSidebar from '@/views/apps/accounting/components/TaxReturnSidebar.vue'
import TaxFilter from '@/views/apps/accounting/components/TaxFilter.vue'
import ThSort from '@/views/components/ThSort.vue'

import { BASE_URL } from '@/urls.js'
import tax from '@/http/requests/tax'
import client from '@/http/requests/client'
import invoice from '@/http/requests/invoice'

export default {
  components: {
    TaxFilter,
    TaxReturnSidebar,
    ThSort
  },
  data() {
    return {
      lastPage: 1,
      tax: null,
      clients: [],
      companies:[],
      selected: [],
      params: {
        search: '',
        page: 1,
        sort:['DESC'],
        sortBy:['tax_return.status']
      },
      filters: {
        requested: true,
        paid: true,
        client: [],
        company:[],
        period_year: '',
        period_month: ''
      }
    }
  },
  computed: {
    taxReturnList() {
      return this.$store.state.accounting.taxTableList
    },
    requestedTax() {
      return this.taxReturnList.filter((item) => {
          return item.status =='REQUESTED'
        })
    },
    selectAllCheckBox: {
      get () {
        return this.selected.length
      },
      set (value) {
        value ? this.selected = this.requestedTax.map(tax => tax.id) : this.selected = []
      }
    },
    selectAllIcon () {
      return this.selected.length === this.requestedTax.length ? 'icon-check' : 'icon-minus'
    }
  },
  created() {
    if (!moduleAccounting.isRegistered) {
      this.$store.registerModule('accounting', moduleAccounting)
      moduleAccounting.isRegistered = true
    }
  },
  mounted() {
    this.tableRefresh()
    this.getClients()
    this.getCompanies()
  },
  methods: {
    tableRefresh() {
      this.topTableScroll()
      this.params.page = 1
      this.getTaxReturnList()
        .then(res => { this.closeTaxLoading() })
        .catch(err => { this.closeTaxLoading() })
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.tableRefresh()
    },
    getTaxReturnList() {
      this.openTaxLoading()
      return this.$store.dispatch(
        'accounting/fetchIvaReturnRequestList',
        this.params
      ).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    openTaxLoading: function () {
      this.$vs.loading({
        container: '#tax-return-loading',
        scale: 0.6
      })
    },
    closeTaxLoading: function () {
      this.$vs.loading.close('#tax-return-loading > .con-vs-loading')
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'tax-filter')
    },
    getClients() {
      client.list().then(res => {
        this.clients = [...res.data.clients]
      })
    },
    getCompanies() {
      client.getCompanies().then(res => {
        this.companies = [...res.data.companies]
      })
  },
    addTaxReturn() {
      this.tax = null
      this.$store.dispatch('toggleSidebar', 'tax-return')
    },
    updateTaxReturn(data) {
      this.tax = data
      this.$store.dispatch('toggleSidebar', 'tax-return')
    },
    showPdf(file) {
      if (file !== '') {
        window.open(
          BASE_URL + 'storage/'+ file,
          file,
          `width=800,height=600,left=50,top=50,toolbar=yes`
        )
      } else {
        this.$vs.notify({
          color: 'warning',
          title: 'Not File attached',
          text: 'Not File attached'
        })
      }
    },
    approve() {
      let params = {
        taxes: this.selected
      }
      this.openTaxLoading()
      tax
        .approve(params)
        .then(res => {
          this.tableRefresh()
          this.selected = []
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Approved'
          })
        })
        .catch(err => {
          console.log(err)
          /* if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function(key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          } */
          this.closeTaxLoading()
        })
    },
    openConfirm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text:this.$i18n.messages[this.$i18n.locale].confirm_tax_return_approve_message,
        accept: this.approve,
        acceptText: this.$i18n.messages[this.$i18n.locale].accept,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
      })
    },
    applyFilters(filters) {
      this.filters = filters
      this.params.client_id = filters.client
      this.params.company = this.filters.company
      this.params.period_year = this.filters.period_year
      this.params.period_month = this.filters.period_month
      this.params.status=[]
      filters.requested ? this.params.status.push("'REQUESTED'") : ''
      filters.paid ? this.params.status.push("'PAID'") : ''
      this.tableRefresh()
    },
    clear() {
      ; (this.params = {
        search: '',
        page: 1,
        sort:['DESC'],
        sortBy:['tax_return.status']
      }),
        this.tableRefresh()
    },
    topTableScroll() {
      let elemento = document.getElementsByClassName('vs-con-tbody vs-table--tbody');
      elemento[0].scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getTaxReturnList()
        .then(res => { this.closeTaxLoading() })
        .catch(err => { this.closeTaxLoading() })
    }
  }
}
</script>

<style>
  .qb-sticky {
  background: white;
  position: sticky;
  top: 0;
}

.text-right{
  text-align: end;
}
</style>
